<script setup>
import { defineEmits } from 'vue';
import NextIcon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm group">
    <button
      class="flex items-center select-none w-full rounded-xl bg-muted/50 border border-border/50 outline-none m-0 cursor-pointer justify-between py-2 px-3 drag-handle transition-all hover:bg-muted"
      :class="{ 'rounded-bl-none rounded-br-none bg-muted border-b-0': isOpen }"
      @click.stop="onToggle"
    >
      <div class="flex items-center gap-2">
        <NextIcon
          v-if="icon"
          class="inline-block w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors"
          :icon="icon"
        />
        <span v-else-if="emoji" class="inline-block w-4 h-4 text-center">{{
          emoji
        }}</span>
        <h5
          class="text-foreground text-[10px] font-bold uppercase tracking-wider mb-0 py-0 pr-2 pl-0 opacity-80 group-hover:opacity-100 transition-opacity"
        >
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-2">
        <slot name="button" />
        <div
          class="flex justify-end text-muted-foreground/60 group-hover:text-primary transition-all"
        >
          <span
            class="size-4 transition-transform duration-300"
            :class="isOpen ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
          />
        </div>
      </div>
    </button>
    <div
      v-if="isOpen"
      class="border border-border/50 border-t-0 rounded-br-xl rounded-bl-xl bg-background/50"
      :class="compact ? 'p-0' : 'px-3 py-3'"
    >
      <slot />
    </div>
  </div>
</template>
